import type { PropsWithChildren } from "react";

import { twMerge } from "tailwind-merge";

export function Banner({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={twMerge(
        "rounded-r-sm border border-l-4 border-y-attention/25 border-r-attention/25 border-l-attention bg-white",
        className,
      )}
    >
      <div className="bg-attention/10 p-4">{children}</div>
    </div>
  );
}
